import React from 'react';

import { InterestsForm } from '@/core/components/InterestsForm/InterestsForm';
import useMutation from '@/core/hooks/useMutation';
import { useEnvContext } from '@/core/lib/env/env.context';
import { ApiMethods } from '@/core/lib/fetch';
import { ApiVersions } from '@/core/lib/fetch/fetch';
import Query from '@/core/lib/new-architecture/query';
import { useTranslationContext } from '@/core/lib/translation/translation.context';

export const InterestsControl: React.FC = () => {
  const { t } = useTranslationContext(['common']);

  const { DONNONS_API_URL } = useEnvContext();
  const user = Query.user.useInvalidate();

  const mutation = useMutation({
    apiDefinition: { method: ApiMethods.PUT, url: `${DONNONS_API_URL}${ApiVersions.V1}/user/control/user_interests` },
  });

  const onCloseModal = async () => {
    await mutation.mutateAsync(undefined);
    await user.invalidate();
  };

  return (
    <InterestsForm
      onCancel={onCloseModal}
      onSubmit={onCloseModal}
      content={`${t('control.interests.profile-saved', { ns: 'common' })}

${t('control.interests.content', { ns: 'common' })}`}
      cancelButtonText={t('control.interests.cancel.control', { ns: 'common' })}
    />
  );
};
